// PrivateRoute.js
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';


const PrivateRoute = ({ children }) => {
  const {  userData, panVerified, aadharVerified } =
    useSelector((state) => state.user);
  const location = useLocation();

  // Derive verification status
  const isMobileVerified = !!userData?.steps; // Has steps = mobile verified
  const isEmailVerified = userData?.steps?.["Email Verify"]?.status;
  const isPanAndAadharVerified = ((panVerified === "true" || userData?.steps?.["Pan Verify"]?.status))
  //  &&
    // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status))


  console.log(isMobileVerified,isEmailVerified,isPanAndAadharVerified)

  const currentPath = location.pathname;

  // Check if all steps are completed (excluding certain steps)
  const excludedSteps = [
    "Add Nominee",
    "Activate F&O",
    "Subscription Plan",
    "Choose Segment",
    "Upload Documents",
    "Congrats Page",
    "POA",
    "Esign",
    "DIS Slip"
  ];




  const stepNames = userData?.steps ? Object.keys(userData.steps).filter(
    name => !excludedSteps.includes(name)
  ) : [];

  console.log("stepNames:", stepNames);

  // Modified check to handle empty array case
  const allStepsComplete = stepNames.length > 0 &&
    stepNames.every(stepName => userData.steps[stepName]?.status);

  console.log("allStepsComplete:", allStepsComplete);


  // If all steps are complete, redirect to products page for any signup/step route
  const signupAndStepRoutes = [
    '/signupphotp',
    '/signupemail',
    '/signupemailotp',
    '/signupcongrats',
    '/step-1',
    '/step-2',
    '/step-3',
    '/step-4',
    '/step-5',
    '/step-6',
    '/step-7',
    '/step-8'
  ];

  // Special handling for /products route
  // if route is /products and steps are not completed it will redirect to home route
  if ((currentPath === '/products' || currentPath==='/dis') && !allStepsComplete) {
    return <Navigate to="/" replace />; // Or redirect to some other page
  }


  // if all steps are completed and if he tries to redirect to other signup and step routes he will be navigated to products page
  // Redirect to products if all steps complete and trying to access signup/step routes
  if (allStepsComplete && signupAndStepRoutes.includes(currentPath)) {
    return <Navigate to="/dis" replace />;
  }

  // Route rules
  // if mobile is not verified, signupphotp route is allowed and if mobile verified then it will check weather email is verified or not, if email not --> /signupemail if email --> signupcongrats
  const routeRules = {
    '/signupphotp': {
      allow: !isMobileVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ? '/signupcongrats' : '/signupemail') :
        '/'
    },
    //  if mobile verified but if email not verified , signupemail is allowed and if mobile verified then if if email also verified then redirect to signcongrats or else nothing
    '/signupemail': {
      allow: isMobileVerified && !isEmailVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ? '/signupcongrats' : null) :
        '/'
    },
    // if mobile verified but if email not verified, signupemailotp is allowed and if mobile verified then if if email also verified then redirect to signcongrats or else if mobile verified not email it will redirect to signup email
    '/signupemailotp': {
      allow: isMobileVerified && !isEmailVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ? '/signupcongrats' : '/signupemail') :
        '/'
    },
    // if mobile and email verified then allow signupcongrats , if mobile and email --> signupcongrats , if mobile , not email it will redirect to /signupemail
    '/signupcongrats': {
      allow: isMobileVerified && isEmailVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ? null : '/signupemail') :
        '/'
    },
    // if mobile and email and pan,aadhaar not verified then allow /step-1 route, if mobile, email , panaadhar verified then /step-2 , if not mobile --> home route , if mobile and email , not pan aadhar be in same route
    '/step-1': {
      allow: isMobileVerified && isEmailVerified && !isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? '/step-2' : null) :
          '/signupemail') :
        '/'
    },

    // if all there allow , if mobile, email , panaadhar verified then /step-2(same route) , if mobile , not email then signupemail and if mobile,email and  not panAadhar then step-1
    '/step-2': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-3': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-4': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-5': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-6': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-7': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    },
    '/step-8': {
      allow: isMobileVerified && isEmailVerified && isPanAndAadharVerified,
      redirect: isMobileVerified ?
        (isEmailVerified ?
          (isPanAndAadharVerified ? null : '/step-1') :
          '/signupemail') :
        '/'
    }
  };

  const rule = routeRules[currentPath] || { allow: true };
  if (!rule.allow) {
    return <Navigate to={rule.redirect || '/'} replace />;
  }
  return children;
};

export default PrivateRoute